import React from 'react'
import './Footer.css'
export default function Footer() {
  return (
    <div className='footerText'>© Copyright 2024. All rights reserved.</div>
  )
}
